module.exports = __webpack_public_path__ + "img/fuwu2.da39950b.png";